// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"style_checkboxWrapper__7bbIi"};